import { render, staticRenderFns } from "./LanguageYN.vue?vue&type=template&id=f1db1018"
import script from "./LanguageYN.vue?vue&type=script&lang=js"
export * from "./LanguageYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports